
const ReportAppDashboardWidgetType = {
  Notifications: 1,
  SubmittedReportGroups: 2,
  Messages: 3
}

export {
  ReportAppDashboardWidgetType
}



// WEBPACK FOOTER //
// ./src/enums/ReportAppDashboardWidgetType.js